module.exports = __webpack_public_path__ + "img/feed.17eed80e.png";